import { Directive, EventEmitter, HostListener, Output } from '@angular/core';
import type { FileDropPayload } from '../models/file-drop.model';

@Directive({
  selector: '[appFileDrop]',
  standalone: true,
})
export class FileDropDirective {
  @Output() dragStateChange = new EventEmitter<boolean>();
  @Output() filesDropped = new EventEmitter<FileDropPayload>();
  @Output() internalDropped = new EventEmitter<string>();

  private dragCounter = 0;

  @HostListener('dragenter', ['$event'])
  onDragEnter(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.dragCounter++;
    if (this.dragCounter === 1) {
      this.dragStateChange.emit(true);
    }
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.dragCounter--;
    if (this.dragCounter === 0) {
      this.dragStateChange.emit(false);
    }
  }

  @HostListener('dragover', ['$event'])
  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.dragCounter = 0;
    this.dragStateChange.emit(false);

    const internalData = event.dataTransfer?.getData('application/json');
    if (internalData) {
      this.internalDropped.emit(internalData);
      return;
    }

    const items = event.dataTransfer?.items;
    const supportsEntries =
      items && items.length > 0 && typeof (items[0] as unknown as { webkitGetAsEntry?: unknown }).webkitGetAsEntry === 'function';

    if (supportsEntries) {
      this.filesDropped.emit({ items });
    } else if (event.dataTransfer?.files && event.dataTransfer.files.length > 0) {
      this.filesDropped.emit({ files: event.dataTransfer.files });
    }
  }
}
